import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CerrixTextInputBase } from "../cerrix-textinput/cerrix-textinput-base";
import { CerrixTextfieldComponent } from "../cerrix-textinput/cerrix-textfield/cerrix-textfield.component";

@Component({
    selector: "cerrix-textfield-with-autohide",
    templateUrl: "./cerrix-textfield-with-autohide.component.html",
    styleUrls: ["./cerrix-textfield-with-autohide.component.scss"],
    imports: [FormsModule, CerrixTextfieldComponent],
})
export class CerrixTextfieldWithAutohideComponent {
    @Input() disabled = false;
    @Input() placeholder = "";
    @Input() noValuePlaceholder = "-";
    @Input() editButtonText = "Edit";
    @Input() required = false;
    @Input() showFullText = false;

    _value = "";

    @Input()
    set value(value: string) {
        if (this._value === value) {
            return;
        }
        this.valueChanged = true;

        this._value = value;
        this.valueChange.emit(value);
    }
    get value(): string {
        return this._value;
    }

    @Output() valueChange = new EventEmitter<string>();
    @Output() valueChangeCompleted = new EventEmitter<string>();

    @ViewChild("cerrixInput") cerrixInput: CerrixTextInputBase;

    private valueChanged: boolean = false;
    showEditMode = false;

    enableEditMode() {
        if (this.disabled) {
            return;
        }

        this.showEditMode = true;
        setTimeout(() => {
            this.cerrixInput.inputField.nativeElement.focus();
        }, 10);
    }

    onBlur() {
        this.showEditMode = false;

        if (this.valueChanged) {
            this.valueChangeCompleted.emit(this.value);
            this.valueChanged = false;
        }
    }
}
